import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import HistoryListComponent from './HistoryList/HistoryList.container.js';

const HistoryPostbackPage = ({ location, t }) => {
    const staticNames = t?.postbackPage?.history || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content tools">
                <div className="ibox history-postback">
                    <HistoryListComponent
                        location={location}
                    />
                </div>
            </section>
        </React.Fragment>
    );
};

HistoryPostbackPage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

HistoryPostbackPage.defaultProps = {
    location: {},
    t: {}
};

export default withTranslation(HistoryPostbackPage);
